export const getBrands = (state, brands) => {
  state.brands = brands
}

export const setLoading = (state, value) => {
  state.loading = value;
}